import { render, staticRenderFns } from "./FaceSuccess.vue?vue&type=template&id=ab2600d8&scoped=true&"
import script from "./FaceSuccess.vue?vue&type=script&lang=ts&"
export * from "./FaceSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./FaceSuccess.vue?vue&type=style&index=0&id=ab2600d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2600d8",
  null
  
)

export default component.exports